import axios from 'axios'


const userApi = axios.create({
    //baseURL: 'https://vue-demos-be3d0-default-rtdb.firebaseio.com'

    baseURL: 'https://conexmetsclm.com/sclm/'
})

// console.log( process.env.NODE_ENV ) // TEST durante testing, 

export default userApi